import SocialMediaWidget from '@ui/social-media-share-view'

export default class extends SocialMediaWidget {
  constructor(model) {
    super(model);
    this.title = model.get('title');
    this.links = model.get('shareLinks');
  }
}



// WEBPACK FOOTER //
// ./src/RMPL/CoreBundle/Resources/public/js/ui/article/social-media-share-view.js